import React, {
    useMemo,
    useState,
    useEffect,
    useCallback,
    useRef,
  } from "react";
  import {
    Container,
    Row,
    Col,
    Button,
    Modal,
    Table,
    Alert,
  } from "react-bootstrap";
  import * as Icon from "react-bootstrap-icons";
  import DropFileInput from "../../reusable-components/DropFileComponent/DropFileComponent";
  import Select from "react-select";
  import "./crossReference.css";
  import "../../reusable-components/InputFields/elements/customelements.css"
  import { Drawer } from "rsuite";
  import { ToastContainer, toast } from "react-toastify";
  import * as XLSX from "xlsx";
  import { logout, capitalizeFirstLetter } from "../../utils";


export const OffCanvasDrawer = (props) => {
    
  const [size, setSize] = React.useState("md");
  const [placement, setPlacement] = React.useState();

  const [errList, setErrorList] = useState([]);

  const [dataHasAnomalies, setDataHasAnomalies] = useState(false);

  const containerStyle = useMemo(() => ({ width: "100%", height: "57vh" }), []);
  const gridStyle = useMemo(() => ({ height: "69vh", width: "100%" }), []);
  const handleOpen = (key) => {
    props.setOpen(true);
    setPlacement(key);
  };
  useEffect(() => {
    if(props.bulkupload===true){
        handleBulkUpload()
    }
  }, [props.bulkupload])
  

  const handleBulkUpload = () => {
    handleOpen("right");
  };

  const clearAndCloseBulkUpload = () => {
    props.setOpen(false);
    setErrorList([]);
    props.setUploadedData([]);
  };

  const checkDiscrepencies = (temp3, temp4) => {
    return temp3.map((elem) => {
      let foundSimilarSource = temp4.filter(
        (el) => el.SourceField == elem.SourceField
      );
      let foundSimilarDestination = temp4.filter(
        (el) => el.DestinationField == elem.DestinationField
      );
      let foundExactDuplicate = temp4.filter(
        (el) =>
          el.DestinationField == elem.DestinationField &&
          el.SourceField == elem.SourceField &&
          el.Active == elem.Active
      );

      let foundSimilarButActiveDifferent = temp4.filter(
        (el) =>
          el.DestinationField == elem.DestinationField &&
          el.SourceField == elem.SourceField &&
          el.Active != elem.Active
      );

      if (foundSimilarSource.length) {
        elem.class = "danger";
      } else {
        elem.class = "ok";
      }

      if (foundExactDuplicate.length) {
        elem.class = "warning";
      }

      if (foundSimilarButActiveDifferent.length) {
        elem.class = "activeMismatch";
      }

      return elem;
    });
  };

  useEffect(() => {
    if (hasAnomalies()) {
      setDataHasAnomalies(true);
    } else {
      setDataHasAnomalies(false);
    }
  }, [props.uploadedData]);

  const onFileChange = async (files) => {
    // console.log("FILES: ", files[0], files);
    const formData = new FormData();
    formData.append("file", files[0]);
    formData.append("report_name", "due_date");
    // console.log("FormDATA: ", formData);

    const file = files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = event && event.target && event.target.result;
      const workbook = XLSX.read(data, { type: "binary" });

      let expectedNumCols = 3;

      // Get the first worksheet in the workbook
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];

      const sheetName = workbook.SheetNames[0];
      const sheet =
        sheetName && workbook && workbook.Sheets && workbook.Sheets[sheetName];
      const sheetData =
        XLSX &&
        XLSX.utils &&
        XLSX.utils.sheet_to_json &&
        XLSX.utils.sheet_to_json(sheet, { header: 1 });

      // Get the number of rows and columns in the worksheet
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const numRows = range.e.r + 1;
      const numCols = range.e.c + 1;

      // Convert the worksheet data to an array of objects
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      let ErrorList = [];

      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = { c: C, r: R };
          const cellRef = XLSX.utils.encode_cell(cellAddress);
          const cell = sheet[cellRef];
          if (cell && cell.v && typeof cell.v === "string") {
            if (cell.v.match(/<script[^>]*>/i)) {
              ErrorList.push("Script injection detected in Excel file.!");
            }
          }
        }
      }

      if (numCols !== expectedNumCols) {
        ErrorList.push(`Invalid file. Expected ${expectedNumCols} columns.`);
      }

      // Validate the data
      rows.filter((row) => {
        return row.some((value) => {
          // Check if the value is a string and contains only special characters
          if (typeof value === "string" && /^[\W_]+$/.test(value)) {
            ErrorList.push(
              "Invalid file. The file contains cells with only special characters.!"
            );
            return true;
          }

          if (
            typeof value === "string" &&
            /(select|update|delete|insert|drop|create|alter|exec|truncate)/i.test(
              value
            )
          ) {
            ErrorList.push(
              "Invalid file. The file contains cells with potential SQL injection keywords."
            );

            return true;
          }
        });
      });

      if (ErrorList.length > 0) {
        // clearAndCloseBulkUpload();
        setErrorList(ErrorList);
        props.setUploadedData([]);
      } else {
        setErrorList([]);
      }

      if (sheetData && ErrorList.length == 0) {
        handleOpen("right");

        if (sheetData && sheetData.length >= 2) {
          let dataToSet = sheetData.splice(1, sheetData.length).map((el) => {
            return {
              SourceField: el[0],
              DestinationField: el[1],
              Active: capitalizeFirstLetter(el[2].toString()),
            };
          });

          let uplodaedDataCheckDiscrepencies = checkDiscrepencies(
            dataToSet,
            props.dataSource
          );

          props.setUploadedData(uplodaedDataCheckDiscrepencies);
        }
      }
    };
    if (reader && reader.readAsBinaryString && file) {
      reader.readAsBinaryString(file);
    }
  };

  const generateTemplate = () => {
    const templateData = [
      { "SOURCE FIELD": "", "DESTINATION FIELD": "", STATUS: "" },
    ];

    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Convert the XLSX file to a base64 string
    const base64 = XLSX.write(wb, { type: "base64" });

    // Trigger a download of the file
    const a = document.createElement("a");
    a.href =
      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
      base64;
    a.download = "template.xlsx";
    a.click();
  };

  const hasAnomalies = () => {
    if (props.uploadedData && props.uploadedData.length >= 1) {
      if (
        props.uploadedData.map((elem) => elem.class).includes("warning") ||
        props.uploadedData.map((elem) => elem.class).includes("danger")
      ) {
        return true;
      } else {
        return false;
      }
      return false;
    }
  };

    return(
        <div>
                {props.open && (
                  <Drawer
                    size={size}
                    placement={placement}
                    open={props.open}
                    backdrop="static"
                    onClose={() => clearAndCloseBulkUpload()}
                  >
                    <Drawer.Header>
                      <Drawer.Title>Bulk Upload</Drawer.Title>
                      <Drawer.Actions>
                        <Button
                          className="custom-button"
                          onClick={() => generateTemplate()}
                        >
                          <Icon.Download /> Download Template
                        </Button>
                        {props.uploadedData &&
                          props.uploadedData.length !== 0 &&
                          !dataHasAnomalies && (
                            <Button
                              className="custom-button"
                              style={{ margin: "0 10px" }}
                              onClick={() => props.handleSaveAndAdd()}
                              appearance="primary"
                            >
                              <Icon.SaveFill /> Save and Add
                            </Button>
                          )}
                        <Button
                          className="custom-button"
                          style={{ margin: "0 10px" }}
                          onClick={() => clearAndCloseBulkUpload()}
                        >
                          <Icon.XLg /> Cancel
                        </Button>
                      </Drawer.Actions>
                    </Drawer.Header>
                    <Drawer.Body>
                      <DropFileInput
                        onFileChange={(files) => onFileChange(files)}
                        fileLimit="single"
                      />
                      {errList &&
                        errList.map((el) => {
                          return (
                            <Alert
                              variant="danger"
                              style={{ marginTop: "15px" }}
                            >
                              <strong>{el} !</strong> please correct it and
                              re-upload the file
                            </Alert>
                          );
                        })}
                      {dataHasAnomalies && (
                        <Alert variant="danger" style={{ marginTop: "15px" }}>
                          <strong>Data has anomalies !</strong> please correct
                          it and re-upload the file
                        </Alert>
                      )}
                      {props.uploadedData && props.uploadedData.length !== 0 && (
                        <>
                          {!dataHasAnomalies && (
                            <Alert
                              variant="success"
                              style={{ marginTop: "15px" }}
                            >
                              <strong>Please confirm !</strong> The Below Data
                              Uploaded shall be added to the Grid
                            </Alert>
                          )}
                          <Container fluid>
                            <Row>
                              <Col xs={6}>
                                <div className="okBox"></div>
                                <span>Ok for bulk add</span>
                              </Col>
                              <Col xs={6}>
                                <div className="warningBox"></div>
                                <span>Exact duplicate</span>
                              </Col>
                              <Col xs={6}>
                                <div className="dangerBox"></div>
                                <span>Source field already exists</span>
                              </Col>
                              <Col xs={6}>
                                <div className="activeMismatchBox"></div>
                                <span>
                                  Source field and destination field exists but
                                  active is different
                                </span>
                              </Col>
                            </Row>
                          </Container>
                        </>
                      )}
                      <Table striped className="mt-3">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Source Field</th>
                            <th>Destination Field</th>
                            <th>Active</th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.uploadedData &&
                            props.uploadedData.map((el, i) => {
                              return (
                                <tr className={el.class} key={i}>
                                  <td>{i + 1}</td>
                                  <td>{el.SourceField}</td>
                                  <td>{el.DestinationField}</td>
                                  <td>{el.Active}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </Table>
                    </Drawer.Body>
                  </Drawer>
                )}
              </div>
    )
}